export const disciplinesForUsers = [
  {
    code: "BC",
    description: "Bereavement",
  },
  {
    code: "MD",
    description: "Doctor of Medicine",
  },
  {
    code: "DO",
    description: "Doctor of Osteopathy",
  },
  {
    code: "HA",
    description: "Hospice Aide",
  },
  {
    code: "LN",
    description: "Licensed Nurse (LPN/LVN)",
  },
  {
    code: "",
    description: "No Discipline",
  },
  {
    code: "NP",
    description: "Nurse Practitioner",
  },
  {
    code: "N",
    description: "Nutritionist",
  },
  {
    code: "OT",
    description: "Occupational Therapist",
  },
  {
    code: "PT",
    description: "Physical Therapist",
  },
  {
    code: "PA",
    description: "Physician Assistant",
  },
  {
    code: "RN",
    description: "Registered Nurse",
  },
  {
    code: "SW",
    description: "Social Worker",
  },
  {
    code: "SLT",
    description: "Speech-Language Therapist",
  },
  {
    code: "SA",
    description: "Spiritual Advisor",
  },
  {
    code: "VOL",
    description: "Volunteer",
  },
  {
    code: "VC",
    description: "Volunteer Coordinator",
  },
];

export const getDisciplineCodeByDescription = (description: string): string => {
  const discipline = disciplinesForUsers.find(
    (d) => d.description === description
  );
  return discipline.code;
};



// WEBPACK FOOTER //
// ./src/configs/discipline-user-config.ts